import React from "react";

const OpeningTiming = () => {
  return (
    <div className="text-center py-14 bg-secondary">
      <div className="container">
        <h2 className="title-secundary leading-none text-primary mb-4 flex flex-col gap-2">
          <span>Open for the 2025 Season</span>
        </h2>
        <div className="flex flex-col md:flex-row justify-center items-center gap-4 w-fit mx-auto">
          <div className="text-white-yale w-fit">
            {/* <p className="text-2xl">Wednesday to Sunday 10:00 am to 5:00 pm</p> */}
            <div className="flex flex-col lg:flex-row gap-1 lg:gap-2">
              <p>Wednesday to Sunday</p>
              <p>10:00 am to 5:00 pm</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpeningTiming;
